import { render, staticRenderFns } from "./ThumbnailCard.vue?vue&type=template&id=b5e5b494&"
import script from "./ThumbnailCard.vue?vue&type=script&lang=js&"
export * from "./ThumbnailCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports